export const IMAGE_WIDTH = '48px';
